// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"MU","sticky_header_title":"NU","stycky_header_title_mob":"OU","root_scroller":"PU","scroller":"QU","indicator":"RU","scrollButtons":"SU","selected":"TU","root_tab_scrollable":"UU","root_scroller_mob":"VU","scroller_mob":"WU","indicator_mob":"XU","selected_mob":"YU","root_tab_mob":"ZU","root_tab_mob_scrollable":"aV","sticky_header_title_mob":"bV"};
    if(module.hot) {
      // 1711394579691
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  